import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import styles from './StackDataList.pcss';
const StackDataList = ({ data })=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.dataList,
        children: data.map((dataElem)=>/*#__PURE__*/ _jsxs("div", {
                className: styles.dataList__elem,
                children: [
                    dataElem.label && /*#__PURE__*/ _jsx("div", {
                        className: styles.dataList__label,
                        children: dataElem.label
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.dataList__value,
                        children: dataElem.value
                    })
                ]
            }, `${dataElem.label}_${dataElem.value}`))
    });
};
export default /*#__PURE__*/ memo(StackDataList);
